import React from "react";
import classNames from "classnames";
import style from "../styles/ng_detail.module.scss";
import {
  Bag,
  GlueTape,
  GlueTapeLogo,
  Pefilm,
  PpTape,
  SpecialTape,
  StretchTape,
  Termofilm,
  Vpp,
} from "../calculators";
import Package from "../calculators/Package";

/*
    stretch_tape - Стретч-плёнки
    glue_tape - Клейкие ленты
    glue_tape_logo - Клейкие ленты с логотипом
    special_tape - Специальные ленты
    vpp - Воздушно-пузырьковые плёнки
    termo_film - Термоусадочные плёнки
    pe_film - Полиэтиленовые плёнки
    tape_pp - ПП и ПЭТ ленты
    bag - Мешки
    package - Пакеты
*/

const renderItemByType = (type) => {
  switch (type) {
    case "stretch_tape":
      return <StretchTape />;
    case "glue_tape":
      return <GlueTape />;
    case "glue_tape_logo":
      return <GlueTapeLogo />;
    case "special_tape":
      return <SpecialTape />;
    case "vpp":
      return <Vpp />;
    case "termo_film":
      return <Termofilm />;
    case "pe_film":
      return <Pefilm />;
    case "tape_pp":
      return <PpTape />;
    case "bag":
      return <Bag />;
    case "package":
      return <Package />;

    default:
      return null;
  }
};

const Calculator = ({ isActive = false, type }) => {
  const panelClasses = classNames({
    [style.tab__panel]: true,
    [style["tab__panel--active"]]: isActive,
  });

  const Item = () => renderItemByType(type);
  return (
    <div className={panelClasses}>
      <Item />
    </div>
  );
};

export default Calculator;
